import { render, staticRenderFns } from "./AccountHistoryCompanion.vue?vue&type=template&id=a56261c2&scoped=true&"
import script from "./AccountHistoryCompanion.vue?vue&type=script&lang=js&"
export * from "./AccountHistoryCompanion.vue?vue&type=script&lang=js&"
import style0 from "./AccountHistoryCompanion.vue?vue&type=style&index=0&id=a56261c2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56261c2",
  null
  
)

export default component.exports